import { Debounce } from "@nyanyajs/utils"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import store, { methods } from "."
import { ActionParams } from "."

const d = new Debounce()
export const getCatalog = async () => {
  d.increase(() => {
    store.dispatch(methods.catalog.GetCatalog())
  }, 700)
}

export const getCatalogEl = (id: Symbol) => {
  return hElObj[id as symbol]
}


export const catalogMethods = {
  GetCatalog: createAsyncThunk(
    'notes/GetCatalog',
    async (
      _,
      thunkAPI
    ) => {

      const { catalog } = store.getState()

      observerList.forEach(ob => {
        ob.disconnect()
      })
      observerList.length = 0
      hElObj = {}

      const editorContentEl = document.querySelector('.ql-editor')
      if (editorContentEl) {
        const editorContentElRect = editorContentEl.getBoundingClientRect()
        console.log('getCatalog', editorContentEl)
        const hList = editorContentEl.querySelectorAll('h1,h2,h3,h4,h5,h6')
        console.log('getCatalog', hList)

        const catalogTemp = [] as typeof state.catalogs

        let hIndexList = new Array(6).fill(0)
        let hCountList = new Array(6).fill(0)

        hList.forEach((h, i) => {
          if (!h.textContent) return
          const id = Symbol()

          const level = Number(h.nodeName.replace("H", ""))
          hCountList[level - 1]++

          if (i === 0 && level !== 1) {
            hIndexList[0] += 1
          }

          hIndexList.forEach((sv, si) => {
            if (level - 1 === si) {
              hIndexList[level - 1] += 1
            }
            if (si > level - 1) {
              hIndexList[si] = 0
            }
          })
          // console.log("hIndexList", hIndexList)

          // String(h1Index) + (h2Index ? "." + h2Index : "") + (h3Index ? "." + h3Index : "")

          catalogTemp.push({
            id,
            index: hIndexList.reduce((index, v, i) => {

              if (i <= level - 1) {

                if (i === 0) {
                  index += String(v)
                } else {
                  if (v) {
                    index = index + String("." + v)
                  }
                }

              }
              return index
            }, ""),
            title: h.textContent || "",
            level,
          })
          hElObj[id] = h


          let observer = new IntersectionObserver((e) => {
            if (e?.[0].boundingClientRect.top - (e?.[0].rootBounds?.top || editorContentElRect.top) <= 10) {

              catalogTemp.some((v, i) => {
                if (v.id === id) {

                  if (e?.[0].isIntersecting) {

                  }
                  return true
                }
              })

              const index = catalogTemp.reduce((index, v, i) => {
                if (v.id === id) {
                  if (e?.[0].isIntersecting) {
                    index = i
                  } else {
                    index = i + 1
                  }
                }
                if (index >= catalogTemp.length - 1) {
                  index = catalogTemp.length - 1
                }
                // console.log("hEl", index, catalogTemp.length)
                // if (index > catalog.showBaseCatalogMaxIndex) {
                //   index = catalog.showBaseCatalogMaxIndex
                // }
                return index
              }, 0)

              thunkAPI.dispatch(catalogSlice.actions.setActiveCatalogId({
                id: catalogTemp[index]?.id,
                index
              }
              ))

            }
          }, {
            root: editorContentEl,
            rootMargin: "0px",
            threshold: 1.0,
          });
          observer.observe(h);

          observerList.push(observer)
        })
        const l = hCountList.reduce((l, v) => {
          if (v === 0 && !l.b) {
            l.v += 1
          }
          if (v) {
            l.b = true
          }
          return l
        }, {
          v: 0,
          b: false
        }).v

        thunkAPI.dispatch(catalogSlice.actions.setCatalogs(catalogTemp.map(v => {
          return {
            ...v,
            level: v.level - l
          }
        })))

        console.log("getCatalog", catalogTemp)
      }
    }
  ),
}

let observerList: IntersectionObserver[] = []

let hElObj = {} as {
  [id: symbol]: Element
}

export const state = {
  showBaseCatalogMaxIndex: 16,
  activeCatalogId: {
    id: undefined as Symbol | undefined,
    index: -1
  },
  clickCatalogId: {
    id: undefined as Symbol | undefined,
    time: 0
  },
  catalogs: [] as {
    id: Symbol,
    index: string,
    title: string
    level: number,
  }[]
}

export const catalogSlice = createSlice({
  name: 'notes',
  initialState: state,
  reducers: {
    setCatalogs: (state, params: ActionParams<typeof state.catalogs>) => {
      state.catalogs = params.payload
    },
    setActiveCatalogId: (state, params: ActionParams<typeof state.activeCatalogId>) => {
      state.activeCatalogId = params.payload
    },
    setClickCatalogId: (state, params: ActionParams<typeof state.clickCatalogId>) => {
      state.clickCatalogId = params.payload
    },
  }
})
